export default {
    accept: 'قبول',
    reject: 'رفض',
    'this-request': 'هذا الطلب',
    'viewed-requests': 'الطلبات التي تم مشاهدتها',
    'delete-request':  'حذف الطلب',
    'the-request-is': 'هذا الطلب',
    'confirm-acceptance': 'تأكيد القبول',
    'confirm-rejection': 'تأكيد الرفض',
    'the-request': 'الطلب'
}